export const faqData = [
  {
    id: 1,
    category: 'Admissions',
    question: 'What is the admission process?',
    answer: 'The admission process involves filling out an online form, appearing for an entrance test, counseling session, and final enrollment. We also offer direct admissions based on previous academic performance for certain courses.'
  },
  {
    id: 2,
    category: 'Admissions',
    question: 'When do new batches start?',
    answer: 'New batches typically start in April-May for Class XI students and June-July for other classes. However, we have rolling admissions throughout the year for various courses. Contact us for current batch schedules.'
  },
  {
    id: 3,
    category: 'Courses',
    question: 'What is the fee structure?',
    answer: 'Fee structure varies by course and duration. Foundation courses start from ₹40,000 per year, while JEE/NEET programs range from ₹80,000 to ₹1,50,000 for two years. Scholarships are available for meritorious students.'
  },
  {
    id: 4,
    category: 'Courses',
    question: 'Do you provide study material?',
    answer: 'Yes, comprehensive study material is provided to all students covering the entire syllabus. This includes topic-wise notes, practice questions, previous year papers, and online resources.'
  },
  {
    id: 5,
    category: 'Facilities',
    question: 'What facilities are available?',
    answer: 'We offer modern classrooms, well-equipped laboratories, library, computer lab, cafeteria, hostel facilities for outstation students, and 24/7 doubt clearing support through our mobile app.'
  },
  {
    id: 6,
    category: 'Academic',
    question: 'How many tests are conducted?',
    answer: 'We conduct weekly chapter tests, monthly comprehensive tests, and All India Test Series (AITS) for JEE/NEET students. Performance reports are shared with parents regularly.'
  },
  {
    id: 7,
    category: 'Academic',
    question: 'What is the student-teacher ratio?',
    answer: 'We maintain an optimal student-teacher ratio of 30:1 in classrooms to ensure individual attention. Doubt clearing sessions are conducted in smaller groups of 10-15 students.'
  },
  {
    id: 8,
    category: 'Academic',
    question: 'Are there separate batches for JEE and NEET?',
    answer: 'Yes, we have separate specialized batches for JEE and NEET preparation. This ensures focused preparation specific to exam patterns and requirements.'
  },
  {
    id: 9,
    category: 'Support',
    question: 'Do you provide counseling support?',
    answer: 'Yes, we have dedicated counselors who provide academic guidance, career counseling, and emotional support to students. Parent-teacher meetings are conducted quarterly.'
  },
  {
    id: 10,
    category: 'Support',
    question: 'Is there a hostel facility?',
    answer: 'Yes, we have separate hostel facilities for boys and girls with all modern amenities including mess, 24/7 security, Wi-Fi, and study halls. Hostel warden supervises student welfare.'
  },
  {
    id: 11,
    category: 'General',
    question: 'What is your success rate?',
    answer: 'We have consistently maintained an 85%+ selection rate in JEE Main and 78%+ in NEET over the past 5 years. Our students have secured top ranks including AIR under 100 multiple times.'
  },
  {
    id: 12,
    category: 'General',
    question: 'Can I join mid-session?',
    answer: 'Yes, mid-session admissions are possible with special bridge courses to help you catch up. However, we recommend joining at the start of the session for best results.'
  }
];

export const faqCategories = [
  { id: 'all', name: 'All Questions' },
  { id: 'admissions', name: 'Admissions' },
  { id: 'courses', name: 'Courses & Fees' },
  { id: 'facilities', name: 'Facilities' },
  { id: 'academic', name: 'Academic' },
  { id: 'support', name: 'Support' },
  { id: 'general', name: 'General' }
];
